import type { ReactElement } from 'react';
import type { AdminUserDetail } from '@xdocs/schemas';
import { cn } from '@xdocs/ui';
import { useAdminT } from '../../../../features/admin/index.js';
import styles from './SessionsTab.module.css';

export interface SessionsTabProps {
  detail: AdminUserDetail;
}

/**
 * F13/F54 sessions read view. OPEN ISSUE (returned in this task's issues
 * list): the frozen `admin.users.get` response (`AdminUserDetail`,
 * `packages/schemas/src/admin.ts`) only carries `activeSessionCount` — no
 * per-device admin-scoped session list/individual-revoke op exists (`
 * session.list`/`session.revoke` are self-scoped only, F13). Rather than
 * fabricate a per-device table this can't back with real data, this shows
 * the real count and points at `ProfileTab`'s "Force-logout sessions"
 * (bulk revoke, the one op that DOES exist) for the actual write.
 */
export function SessionsTab({ detail }: SessionsTabProps): ReactElement {
  const { t } = useAdminT();

  return (
    <div className={cn(styles['panel'])}>
      <p className={cn(styles['count'])}>{t('admin:userDetail.sessions.activeCount', { count: detail.activeSessionCount })}</p>
      <p className={cn(styles['description'])}>{t('admin:userDetail.sessions.description')}</p>
    </div>
  );
}
